import { useMemo } from 'react';
import { Form } from 'react-final-form';

import NavigatorContent from 'components/NavigatorContent';
import { InitialValues } from 'forms/types';
import useNavigatorTracking from 'hooks/useNavigatorTracking';
import Steps from 'hooks/useNavigatorTracking/steps';
import { Gender } from 'types/graph';

import { HEADING } from './constants';
import DiabetesForm from './form';
import { DiabetesFormValues } from './form/types';
import { getValidator } from './utils/validate';

const Diabetes = () => {
  const trackStepCompleted = useNavigatorTracking(Steps.Diabetes);

  // TODO: get customer's actual DOB and gender; currently hardcoded for UI buildout
  const dateOfBirth = '1987-02-19T00:00:00Z';
  const gender = Gender.Female;
  const validate = useMemo(() => getValidator({ dateOfBirth, gender }), [dateOfBirth, gender]);

  const onSubmit = (values: DiabetesFormValues) => {
    console.log('Diabetes Values', values);
    trackStepCompleted();
  };

  return (
    <NavigatorContent heading={HEADING} title={Steps.Diabetes}>
      <Form<DiabetesFormValues, InitialValues<DiabetesFormValues>>
        onSubmit={onSubmit}
        validate={validate}
      >
        {(formProps) => <DiabetesForm gender={gender} {...formProps} />}
      </Form>
    </NavigatorContent>
  );
};

export default Diabetes;
